import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import './assets/scss/pub.scss'

Vue.config.productionTip = false

Vue.filter('formatMoney', function (amount, curr='£', decPlaces = 2, decSep='.', thouSep=',') {
  if (amount == 0) {
    return 'n/a'
  }
  let number = amount/100;
  decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
      decSep = typeof decSep === "undefined" ? "." : decSep;
  thouSep = typeof thouSep === "undefined" ? "," : thouSep;
  var sign = number < 0 ? "-" : "";
  var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
  var j = (j = i.length) > 3 ? j % 3 : 0;

  return sign + curr +
      (j ? i.substr(0, j) + thouSep : "") +
      i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
      (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "") ;
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
